export default __webpack_public_path__ + "static/media/dhana.e8584703.jpg";